/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Empty_TitleInputs */

const en_inbox_empty_title = /** @type {(inputs: Inbox_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No conversations yet`)
};

const es_inbox_empty_title = /** @type {(inputs: Inbox_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay conversaciones`)
};

const fr_inbox_empty_title = /** @type {(inputs: Inbox_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune conversation pour le moment`)
};

const de_inbox_empty_title = /** @type {(inputs: Inbox_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Unterhaltungen`)
};

const ja_inbox_empty_title = /** @type {(inputs: Inbox_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだメッセージはありません`)
};

const zh_inbox_empty_title = /** @type {(inputs: Inbox_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无对话`)
};

const ar_inbox_empty_title = /** @type {(inputs: Inbox_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد محادثات بعد`)
};

const id_inbox_empty_title = /** @type {(inputs: Inbox_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada percakapan`)
};

const it_inbox_empty_title = /** @type {(inputs: Inbox_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna conversazione`)
};

const ru_inbox_empty_title = /** @type {(inputs: Inbox_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока нет сообщений`)
};

const pt_inbox_empty_title = /** @type {(inputs: Inbox_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma conversa ainda`)
};

const ko_inbox_empty_title = /** @type {(inputs: Inbox_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 대화가 없습니다`)
};

/**
* | output |
* | --- |
* | "No conversations yet" |
*
* @param {Inbox_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const inbox_empty_title = /** @type {((inputs?: Inbox_Empty_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Empty_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inbox_empty_title(inputs)
	if (locale === "es") return es_inbox_empty_title(inputs)
	if (locale === "fr") return fr_inbox_empty_title(inputs)
	if (locale === "de") return de_inbox_empty_title(inputs)
	if (locale === "ja") return ja_inbox_empty_title(inputs)
	if (locale === "zh") return zh_inbox_empty_title(inputs)
	if (locale === "ar") return ar_inbox_empty_title(inputs)
	if (locale === "id") return id_inbox_empty_title(inputs)
	if (locale === "it") return it_inbox_empty_title(inputs)
	if (locale === "ru") return ru_inbox_empty_title(inputs)
	if (locale === "pt") return pt_inbox_empty_title(inputs)
	return ko_inbox_empty_title(inputs)
});